<div class="body" [style.height.px]="mapHeight" [style.width.px]="mapWidth">
    <span class="closer-wrapper">
        <mat-icon class="icon" (click)="close()">close</mat-icon>
    </span>
    <img *ngIf="hereURI" [style.height.px]="mapHeight" [style.width.px]="mapWidth" class="image" src={{hereURI}} />
    <div *ngIf="searched" class="info-wrapper">
        <mat-icon class="icon">location_on</mat-icon>
        <div class="information">
            <div class="street">{{street}}</div>
            <div>
                <span *ngIf="zipCode" class="zip-code">{{zipCode}}</span>
                <span *ngIf="city">{{city}}</span>
            </div>
            <div *ngIf="country">
                <span class="flag-icon {{country.flagIcon}} flag-icon-squared"></span>
                <span>
                    {{country.name}}
                </span>
            </div>
        </div>
        <div class="control-row">
            <button mat-icon-button matTooltip="Hineinzoomen" (click)="zoomIn()">
                <mat-icon>zoom_in</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Hinauszoomen" (click)="zoomOut()">
                <mat-icon>zoom_out</mat-icon>
            </button>
        </div>
    </div>
</div>